import { ContextualMenuItemType, FontIcon, Icon, IContextualMenuItem, IContextualMenuItemProps, IRenderFunction, IStackItemStyles, mergeStyleSets, MessageBar, MessageBarButton, MessageBarType, ScrollablePane, ScrollbarVisibility, Stack } from "@fluentui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ContentManagerCopyMoveModeEnum } from "../../src/taskpane/components/enums/ContentManagerCopyMoveModeEnum";
import { SearchedOneDriveDirectoryBuilder } from "../../src/taskpane/components/helpers/searchedOneDriveDirectoryBuilder";
import { SearchedSharepointFoldersDirectoryBuilder } from "../../src/taskpane/components/helpers/searchedSharepointFoldersDirectoryBuilder";
import { SearchOpenExtensionHelper } from "../../src/taskpane/components/helpers/SearchOpenExtensionHelper";
// import { useLazyGetFileThumbnailQuery, useLazyGetItemsSharedWithMeQuery, useLazyGetItemsTrendingAroundMeQuery, useLazyGetItemsViewedAndModifiedByMeQuery } from "../../src/taskpane/components/_v2/redux/api/graph/api-graph-insights-slice";
import { IGraphInsightsItem, InsightContainerTypes } from "../../src/taskpane/components/_v2/redux/api/graph/api-graph-interfaces";
import { useLazyGetItemQuery, useLazyGetSiteIdFromDriveIdQuery } from "../../src/taskpane/components/_v2/redux/api/graph/api-graph-slice";
import { RootState } from "../../src/taskpane/components/_v2/redux/storeMain";
import { extensions, officeFileType } from "../../src/taskpane/config/constants";
import { IDirectoryBuilder } from "../../src/taskpane/interfaces/IDirectoryBuilder";
import { cancelContentManagerMoveTo, setContentManagerExchange, setIsContentManagerContentLoading } from "../../src/taskpane/redux/modules/contentManagerDirectory";
import { setFiles } from "../../src/taskpane/redux/modules/file";
import { resetWorkingDirectories, setOneDriveDetails } from "../../src/taskpane/redux/modules/workingDirectory";
import { getListItemWebUrl, getOneDriveRootDetails } from "../../src/taskpane/services/GraphService";
import authModule from "../../utilities/AuthModule";
import { OpenPdfInBrowser } from "../../utilities/BrowserUtils";
import { tryDecodeUriComponent } from "../../utilities/EncodeDecode";
import { LanguageContext } from "../../utilities/LocalizationModule";
import { ContentManagerHomeEnum } from "../../src/taskpane/components/enums/ContentManagerHomeEnum";
import { ContentHomePinned } from "./ContentHomePinned";
import { ContentHomeRecent } from "./ContentHomeRecent";
import { ContentHomeShared } from "./ContentHomeShared";
import { getFileTypeIconProps } from "@fluentui/react-file-type-icons";
import { FolderTypeIconQuery } from "../../src/taskpane/components/helpers/folderTypeIconQuery";
import { ImageTypeEnum } from "../../src/taskpane/components/enums/ImageTypeEnum";
import { ImageSizeEnum } from "../../src/taskpane/components/enums/ImageSizeEnum";
import { homeBrandIconStyles, homeFontIconStyles, homeFontIconStylesMedium, iconDisplayStyle } from "../../src/taskpane/styles/iconStyles";
import { FolderTypeIconEnum } from "../../src/taskpane/components/enums/FolderTypeIconEnum";
import { IStoreItem } from "../../src/taskpane/interfaces/IStoredItem";
import { brandedCommandbarIconStyles } from "../../src/taskpane/config/controlStyles";
const mime = require("mime");

const classNames = mergeStyleSets({
    wrapper: {
        height: "calc(100vh - 100px)", //subtract header and breadcrumb heigths
        position: "relative",
    }
});

const headerContainerStackItemStyles: IStackItemStyles = {
    root: {
        marginTop: 15,
        overflowX: "auto",
        overflowY: "hidden",
        maxWidth: "calc(100vw - 400px)"
    }
};

const headerContainerCollapsedStackItemStyles: IStackItemStyles = {
    root: {
        marginTop: 15,
        overflowX: "auto",
        overflowY: "hidden",
        maxWidth: "calc(100vw - 85px)"
    }
};


const filterContainerStackItemStyles: IStackItemStyles = {
    root: {
        marginBottom: 10
    }
};

export const getFileExtension = (item: IGraphInsightsItem) => {
    return mime.getExtension(item.resourceVisualization?.mediaType);
}

export interface IContentManagerHomeProps {
}

export interface HomeItemType {
    fileType: number;
    folderTypeIcon?: number;
    extension?: string;
}

export const ContentManagerHome = ({ }: IContentManagerHomeProps) => {
    const languageStrings = React.useContext(LanguageContext);

    const dispatch = useDispatch();

    const allowOpenInSharePoint = useSelector((state: RootState) => state.user.tenantAllowOpenInSharePoint ?? true);
    const oneDriveWebUrl = useSelector((state: RootState) => state.user.oneDriveWebUrl);
    const sites = useSelector((state: RootState) => state.sharePointInfo.sites);
    const teams = useSelector((state: RootState) => state.teams.teams);
    const moveTo = useSelector((state: RootState) => state.contentManagerDirectory.moveTo);
    const selectedHomeSection = useSelector((state: RootState) => state.contentManagerDirectory.selectedHomeSection);
    const recent = useSelector((state: RootState) => state.recent);
    const pinned = useSelector((state: RootState) => state.pinned);
    const shared = useSelector((state: RootState) => state.shared);
    const isSideMenuCollapsed = useSelector((state: RootState) => state.contentManagerDirectory.isSideMenuCollapsed);

    const [fileTypeList, setFileTypeList] = React.useState<HomeItemType[]>([]);
    const [selectedFileTypeFilter, setSelectedFileTypeFilter] = React.useState<HomeItemType>();

    // const [getItemsTrendingAroundMe, { data: dataTrendingApi, isFetching: isFetchingTrending }] = useLazyGetItemsTrendingAroundMeQuery();
    // const [getItemsSharedWithMe, { data: dataSharedApi, isFetching: isFetchingShared }] = useLazyGetItemsSharedWithMeQuery();
    // const [getItemsViewedAndModifiedByMe, { data: dataViewedApi, isFetching: isFetchingViewed }] = useLazyGetItemsViewedAndModifiedByMeQuery();
    // const [getFileThumbnail] = useLazyGetFileThumbnailQuery();

    const [getSiteIdFromDriveId] = useLazyGetSiteIdFromDriveIdQuery();
    const [getItem] = useLazyGetItemQuery();

    React.useEffect(() => {
        if (fileTypeList?.length > 0) {
            const allFilterItem = fileTypeList.find(x => !x.extension && !x.folderTypeIcon);
            setSelectedFileTypeFilter(allFilterItem);
        }
    }, [selectedHomeSection, fileTypeList]);

    // const [dataViewed, setDataViewed] = React.useState<IGraphInsightsItem[]>([]);
    // const [dataShared, setDataShared] = React.useState<IGraphInsightsItem[]>([]);
    // const [dataTrending, setDataTrending] = React.useState<IGraphInsightsItem[]>([]);

    // const windowSize = useWindowSize();

    // React.useEffect(() => {
    //     getItemsTrendingAroundMe(null, true);
    //     getItemsSharedWithMe(null, true);
    //     getItemsViewedAndModifiedByMe(null, true);
    // }, []);

    // React.useEffect(() => {
    //     (async () => {
    //         if (dataViewedApi) {
    //             setDataViewed(dataViewedApi);

    //             const thumbnails = await Promise.all(dataViewedApi.map(async item => {
    //                 try {
    //                     const thumbs = await getFileThumbnail({ itemDriveId: item.resourceReference.id }, true).unwrap();
    //                     return thumbs?.value?.length > 0
    //                         ? thumbs.value[0].large.url
    //                         : null;
    //                 } catch (error) {
    //                     logger(error, "ContentManagerHome.tsx (thumbnails)");
    //                 }
    //                 return null;
    //             }));

    //             setDataViewed(dataViewedApi.map((item, index) => {
    //                 return {
    //                     ...item,
    //                     imagePreview: thumbnails[index] && {
    //                         previewImages: [{
    //                             name: item.resourceVisualization.title,
    //                             linkProps: {
    //                                 href: item.resourceReference.webUrl,
    //                                 target: '_blank',
    //                             },
    //                             previewImageSrc: thumbnails[index],
    //                             imageFit: ImageFit.none,
    //                             height: 132,
    //                         }]
    //                     }
    //                 }
    //             }))
    //         }
    //     })();
    // }, [dataViewedApi]);

    // React.useEffect(() => {
    //     (async () => {
    //         if (dataSharedApi) {
    //             setDataShared(dataSharedApi);
    //         }
    //     })();
    // }, [dataSharedApi]);

    // React.useEffect(() => {
    //     (async () => {
    //         if (dataTrendingApi) {
    //             setDataTrending(dataTrendingApi);
    //         }
    //     })();
    // }, [dataTrendingApi]);

    React.useEffect(() => {
        const uniqueFileTypeList: HomeItemType[] = [{
            fileType: 0
        }];

        let itemList: IStoreItem[] = [];

        if (selectedHomeSection === ContentManagerHomeEnum.Pinned && pinned && !pinned.isPinnedItemsLoading && pinned.pinnedItems && pinned.pinnedItems?.length > 0) {
            itemList = [...pinned.pinnedItems]
        }
        if (selectedHomeSection === ContentManagerHomeEnum.Recent && recent && !recent.isRecentItemsLoading && recent.recentItems && recent.recentItems?.length > 0) {
            itemList = [...recent.recentItems]
        }
        if (selectedHomeSection === ContentManagerHomeEnum.Shared && shared && !shared.isSharedItemsLoading && shared.sharedItems && shared.sharedItems?.length > 0) {
            itemList = [...shared.sharedItems]
        }

        let uniqueFileTypes = new Set();
        let uniqueExtensions = new Set();
        let uniqueFolderTypeIcons = new Set();

        itemList?.forEach(obj => {
            uniqueFileTypes.add(obj.fileType);

            if (obj.fileType === 1) {
                if (obj.extension) {
                    uniqueExtensions.add(obj.extension);
                }
            } else if (obj.fileType === 0) {
                uniqueFolderTypeIcons.add(obj.folderTypeIcon);
            }
        });

        // let uniqueFileTypesList = Array.from(uniqueFileTypes);
        let uniqueExtensionsList: string[] = Array.from(uniqueExtensions) as string[];
        let uniqueFolderTypeIconsList: number[] = Array.from(uniqueFolderTypeIcons) as number[];

        uniqueExtensionsList?.forEach(ext => {
            uniqueFileTypeList.push({
                fileType: 0,
                extension: ext
            })
        });

        uniqueFolderTypeIconsList?.forEach(icon => {
            uniqueFileTypeList.push({
                fileType: 1,
                folderTypeIcon: icon
            })
        });

        setFileTypeList(uniqueFileTypeList);

    }, [pinned, recent, shared, selectedHomeSection]);

    const getHomeHeading = () => {
        switch (selectedHomeSection) {
            case ContentManagerHomeEnum.Pinned:
                return languageStrings.Pinned;
            case ContentManagerHomeEnum.Recent:
                return languageStrings.Recent;
            case ContentManagerHomeEnum.Shared:
                return languageStrings.Shared;
            default:
                return languageStrings.Home
        }
    }

    const getOpenButtonItems = (item: IGraphInsightsItem): IContextualMenuItem[] => {
        const itemInfo = SearchOpenExtensionHelper.determineOfficeFileType(getFileExtension(item));

        const locationDocubird: IContextualMenuItem = {
            key: "openDocubird",
            iconProps: { iconName: "FolderOpen" },
            text: languageStrings.OpenFileLocation,
            onClick: () => {
                (async () => {
                    openFileInContentManager(item);
                })();
            }
        };

        const web: IContextualMenuItem = {
            key: "online",
            text: `${languageStrings.OpenIn} ${itemInfo?.type} ${itemInfo?.type !== officeFileType.Browser ? "online" : ""}`,
            iconProps: { iconName: itemInfo?.iconName ? itemInfo.iconName : "SharepointLogo" },
            onClick: () => {
                (async () => {
                    if (getFileExtension(item)?.toLowerCase() === extensions.pdf) {
                        const resourceParts = item.resourceReference?.id?.split("/");
                        const driveId = resourceParts?.length >= 2 && resourceParts[1];
                        const itemId = resourceParts?.length >= 4 && resourceParts[3];

                        if (itemId && driveId) {
                            OpenPdfInBrowser((await authModule.getAccount(false)), driveId, itemId, item.resourceReference.webUrl?.startsWith(oneDriveWebUrl));
                        }
                        else {
                            window.open(item.resourceReference.webUrl);
                        }
                    }
                    else {
                        window.open(item.resourceReference.webUrl, "_blank");
                    }
                })();
            },
            onRenderIcon: (props: IContextualMenuItemProps, defaultRender?: IRenderFunction<IContextualMenuItemProps>) => {
                return itemInfo && itemInfo.type !== officeFileType.Browser ? <img src={itemInfo.iconSrc} className={brandedCommandbarIconStyles} /> : defaultRender({ ...props })
            },
        };

        const local: IContextualMenuItem = {
            key: "app",
            text: `${languageStrings.OpenIn} ${itemInfo?.type} ${languageStrings.Local}`,
            iconProps: { iconName: itemInfo?.iconName },
            onClick: () => {
                (async () => {
                    let url = item.resourceReference.webUrl;

                    const resourceParts = item.resourceReference?.id?.split('/');
                    let itemId = resourceParts?.length >= 4 && resourceParts[3];
                    let driveId = resourceParts?.length >= 2 && resourceParts[1];

                    url = await getListItemWebUrl(await authModule.getGraphAccessToken(), driveId, itemId);

                    window.open(`${itemInfo.localUrlPrepended}${url}`, "_blank");
                })();
            },
            onRenderIcon: (props: IContextualMenuItemProps, defaultRender?: IRenderFunction<IContextualMenuItemProps>) => {
                return itemInfo && itemInfo.type !== officeFileType.Browser ? <img src={itemInfo.iconSrc} className={brandedCommandbarIconStyles} /> : defaultRender({ ...props })
            },
        };

        const divider: IContextualMenuItem = {
            key: "devider",
            itemType: ContextualMenuItemType.Divider
        };

        const currentLocation: IContextualMenuItem = {
            key: "openCurrentLocation",
            iconProps: { iconName: item?.resourceVisualization?.containerType?.toLowerCase() === InsightContainerTypes.OneDriveBusiness ? "OneDriveLogo" : "SharepointLogo" },
            text: getOpenCurrentLocationText(item),
            onClick: () => {
                (async () => {
                    window.open(item.resourceVisualization.containerWebUrl, "_blank");
                })();
            }
        };

        let menuItems: IContextualMenuItem[] = [];
        if (allowOpenInSharePoint === false) {
            menuItems = itemInfo?.type == officeFileType.Browser ? [locationDocubird] : [web, local, divider, locationDocubird];
        }
        else {
            menuItems = itemInfo?.type == officeFileType.Browser ? [web] : [web, local];

            const containerType = item?.resourceVisualization?.containerType?.toLowerCase();

            if (containerType === InsightContainerTypes.Site || containerType === InsightContainerTypes.OneDriveBusiness) {
                menuItems.push(divider);
                menuItems.push(locationDocubird);
                menuItems.push(currentLocation);
            }
        }

        return menuItems;
    };

    const getOpenCurrentLocationText = (item: IGraphInsightsItem) => {
        const containerType = item?.resourceVisualization?.containerType?.toLowerCase();

        if (containerType === InsightContainerTypes.Site) {
            return `${languageStrings.OpenFileLocationIn} SharePoint`;
        }

        if (containerType === InsightContainerTypes.OneDriveBusiness) {
            return `${languageStrings.OpenFileLocationIn} OneDrive`;
        }

        return languageStrings.OpenFolderInBrowser;
    }

    const openFileInContentManager = async (item: IGraphInsightsItem) => {
        dispatch(setIsContentManagerContentLoading(true));

        const resourceParts = item.resourceReference?.id?.split('/');
        let driveId = resourceParts?.length >= 2 && resourceParts[1];
        let itemId = resourceParts?.length >= 4 && resourceParts[3];

        const [parentSite, graphItem] = await Promise.all([getSiteIdFromDriveId({ driveId, accessToken: await authModule.getGraphAccessToken() }).unwrap(), getItem({ driveId, itemId, accessToken: await authModule.getGraphAccessToken() }).unwrap()]);

        const parentItem = await getItem({ driveId: graphItem.parentReference.driveId, itemId: graphItem.parentReference.id, accessToken: await authModule.getGraphAccessToken() }).unwrap()

        const driveItemResult = {
            id: parentItem.id,
            name: parentItem.name,
            driveId: parentItem.parentReference?.driveId,
            lastModifiedDateTime: parentItem.lastModifiedDateTime,
            webUrl: parentItem.webUrl,
            siteId: parentSite.list.parentReference?.siteId,
            path: tryDecodeUriComponent(new URL(parentItem.webUrl)?.pathname),
        }

        const containerType = item?.resourceVisualization?.containerType?.toLowerCase();

        let directoryBuilder: IDirectoryBuilder;
        if (containerType === InsightContainerTypes.OneDriveBusiness) {
            let oneDriveDetails = await getOneDriveRootDetails();
            dispatch(setOneDriveDetails(oneDriveDetails));
            directoryBuilder = new SearchedOneDriveDirectoryBuilder(oneDriveWebUrl, oneDriveDetails.sharePointListId);
        }
        else {
            directoryBuilder = new SearchedSharepointFoldersDirectoryBuilder(sites, teams, null, null);
        }
        const directories = await directoryBuilder.getFolderDirectories(driveItemResult);

        dispatch(resetWorkingDirectories(directories));
        dispatch(setIsContentManagerContentLoading(false));
    }

    const getFolderIconTypeName = (item: HomeItemType) => {
        switch (item.folderTypeIcon) {
            case FolderTypeIconEnum.sharepointFolder:
                return "Folder"

            case FolderTypeIconEnum.sharepointSite:
                return "Sites"

            case FolderTypeIconEnum.documentLibrary:
                return "Library"

            case FolderTypeIconEnum.oneDrive:
                return "One Drive"

            case FolderTypeIconEnum.oneDriveSubFolder:
                return "One Drive SubFolder"

            case FolderTypeIconEnum.teamChannel:
                return "Channels"

            case FolderTypeIconEnum.teamMainSite:
                return "Team Sites"

            case FolderTypeIconEnum.teamFolder:
                return "Team Folder"

            case FolderTypeIconEnum.sharepointDocumentSet:
                return "Document Set"

            case FolderTypeIconEnum.sharepointList:
                return "Lists"

            case FolderTypeIconEnum.sharepointHubSite:
                return "Hub Sites"

            case FolderTypeIconEnum.docubird:
                return "Docubird"

            default:
                return "";
        }
    }


    // export enum FolderTypeIconEnum {
    //     default,
    //     sharepointFolder,
    //     sharepointSite,
    //     documentLibrary,
    //     oneDrive,
    //     oneDriveSubFolder,
    //     teamChannel,
    //     teamMainSite,
    //     teamFolder,
    //     sharepointDocumentSet,
    //     sharepointList,
    //     sharepointHubSite
    // }

    const getFontIconClassName = (fontIcon): string => {
        if (fontIcon.imageSize === ImageSizeEnum.medium) {
            return homeFontIconStylesMedium;
        }
        return homeFontIconStyles;
    }

    const getFolderIconTypeIcon = (item: HomeItemType) => {
        const folderIcon = FolderTypeIconQuery.getImage(item.folderTypeIcon);
        return folderIcon.imageType === ImageTypeEnum.fileType
            ? <Icon {...getFileTypeIconProps({ type: folderIcon.fileIconType, size: 20, imageFileType: "svg" })} styles={iconDisplayStyle} />
            : folderIcon.imageType === ImageTypeEnum.url
                ? <img src={folderIcon.location} className={homeBrandIconStyles} width={20} height={20} />
                : folderIcon.svgComponent;
    }

    return (
        <>
            {moveTo.moveToEnabled && (moveTo.mode === ContentManagerCopyMoveModeEnum.CopySelectedEmails || moveTo.mode === ContentManagerCopyMoveModeEnum.CopyEntireFolderEmails) &&
                <div style={{ paddingTop: "5px", paddingRight: "5px" }}>
                    <MessageBar
                        messageBarType={MessageBarType.warning}
                        isMultiline={false}
                        dismissButtonAriaLabel="Close"
                        actions={
                            <div>
                                <MessageBarButton onClick={() => {
                                    dispatch(cancelContentManagerMoveTo());
                                    dispatch(setContentManagerExchange({ selectedFolderId: "", selectedFolderName: "", selectedAccount: "" }));

                                    dispatch(setFiles([]));
                                }}>{languageStrings.Reset}</MessageBarButton>
                            </div>
                        }
                    >
                        {languageStrings.AttentionSaveModeActive}
                    </MessageBar>
                </div>}
            <Stack verticalAlign="center" styles={!isSideMenuCollapsed ? headerContainerStackItemStyles : headerContainerCollapsedStackItemStyles}>
                <div className="heading">{getHomeHeading()}</div>
                <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 15 }} styles={filterContainerStackItemStyles}>
                    {selectedFileTypeFilter && fileTypeList && fileTypeList.length > 0 && fileTypeList.map((item, index) => {
                        return (
                            <Stack.Item key={index}
                                className={`home-filter-icon-container ${selectedFileTypeFilter?.extension === item?.extension && selectedFileTypeFilter?.folderTypeIcon === item?.folderTypeIcon ? "home-filter-icon-container-active" : ""}`}
                                onClick={() => setSelectedFileTypeFilter(item)}
                            >
                                {item.extension && (
                                    <Stack horizontal tokens={{ childrenGap: 6 }} verticalAlign="center">
                                        <Stack.Item className="home-filter-icon-container-icon">
                                            <Icon
                                                {...getFileTypeIconProps({
                                                    extension: item.extension,
                                                    size: 20,
                                                    imageFileType: "svg"
                                                })}
                                            />
                                        </Stack.Item>
                                        <Stack.Item className="home-filter-icon-container-text">
                                            {item.extension}
                                        </Stack.Item>
                                    </Stack>
                                )}
                                {item.folderTypeIcon && (
                                    <Stack horizontal tokens={{ childrenGap: 6 }} verticalAlign="center">
                                        <Stack.Item className="home-filter-icon-container-icon">
                                            {getFolderIconTypeIcon(item)}
                                        </Stack.Item>
                                        <Stack.Item className="home-filter-icon-container-text">
                                            {getFolderIconTypeName(item)}
                                        </Stack.Item>
                                    </Stack>
                                )}
                                {!item.folderTypeIcon && !item.extension && (
                                    <Stack.Item className="home-filter-icon-container-text-all">
                                        <div>{languageStrings.All}</div>
                                    </Stack.Item>
                                )}
                            </Stack.Item>
                        )
                    })}
                </Stack>
            </Stack>
            <div className={classNames.wrapper}>
                <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                    {selectedHomeSection === ContentManagerHomeEnum.Pinned && <ContentHomePinned selectedHomeFilterType={selectedFileTypeFilter} />}
                    {selectedHomeSection === ContentManagerHomeEnum.Recent && <ContentHomeRecent selectedHomeFilterType={selectedFileTypeFilter} />}
                    {selectedHomeSection === ContentManagerHomeEnum.Shared && <ContentHomeShared selectedHomeFilterType={selectedFileTypeFilter} />}

                    {/* <ContentHomeRecommended dataViewed={dataViewed} isLoading={isFetchingViewed} windowSize={windowSize} getOpenButtonItems={getOpenButtonItems}/> */}
                    {/* <ContentHomeQuickAccess dataShared={dataShared} dataTrending={dataTrending} dataViewed={dataViewed} isLoading={isFetchingTrending || isFetchingShared || isFetchingViewed} windowSize={windowSize} getOpenButtonItems={getOpenButtonItems} /> */}
                    {/* <ContentHomeFollowedSites /> */}
                </ScrollablePane>
            </div>
        </>
    )
};